import { ReactNode, useState } from 'react';

import { RentCatalogArrayQueryParam } from '@/lib/entities/rent';
import { SaleCatalogArrayQueryParam } from '@/lib/entities/sale/model';

import { IValueLabel } from '@/lib/shared/components/Selects/model/value-label';
import { P2 } from '@/lib/shared/components/Typography';
import { PlusIcon, MinusIcon } from '@/lib/shared/icons';

import { useTranslation } from 'next-i18next';

import styles from './options-block.module.scss';

import { CheckboxBlock } from '../checkbox-block';

type Props = {
  items: IValueLabel[];
  children?: ReactNode;
  title?: string;
} & (
  | {
      catalogQuery: SaleCatalogArrayQueryParam;
      type: 'sale';
    }
  | {
      catalogQuery: RentCatalogArrayQueryParam;
      type: 'rent';
    }
);
export const OptionsBlock = ({
  items,
  catalogQuery,
  children,
  title,
  type,
}: Props) => {
  const [shownCount, setShownCount] = useState(10);
  const { t } = useTranslation('index');
  const isTwoColumns = [
    'phuketBeaches',
    'samuiBeaches',
    'district',
    'facilities',
  ].includes(catalogQuery);

  const hasExpandButton = items.length > 10;
  const isExpanded = shownCount === 10;

  return (
    <div className={styles.modal__filterBlock}>
      <P2 className={styles.modal__filterTitle}>
        {title ||
          t(
            catalogQuery === 'beachDistance'
              ? 'catalog.beachDistance'
              : catalogQuery
          )}
      </P2>
      {type === 'rent' ? (
        <CheckboxBlock
          items={items.slice(0, shownCount)}
          isTwoColumns={isTwoColumns}
          catalogQuery={catalogQuery}
          type={type}
        />
      ) : (
        <CheckboxBlock
          items={items.slice(0, shownCount)}
          isTwoColumns={isTwoColumns}
          catalogQuery={catalogQuery}
          type={type}
        />
      )}
      {hasExpandButton && (
        <button
          onClick={() => setShownCount(() => (isExpanded ? items.length : 10))}
          className={styles.modal__expand}
        >
          <P2>{t(isExpanded ? 'expand' : 'collapse')}</P2>
          {isExpanded ? <PlusIcon /> : <MinusIcon />}
        </button>
      )}
      {children}
    </div>
  );
};
